import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import { Tooltip, Progress, FloatButton } from "antd";
import Button from "@mui/material/Button";
import { colors } from "@mui/material";
import "../../assets/styles/local/TaskMain.css";
import "../../assets/styles/local/popage.css";
import "../../assets/styles/local/contactTaskPopup.css";
import trash from "../../assets/icons/DeleteIcon.svg";
import x from "../../assets/icons/x-circle.svg";
import TextField from "@mui/material/TextField";
import {
  BuildPO,
  GetProject,
  GetClient,
  GetCompletedTask,
  GetResources,
  MakePO,
  GetWorkList,
  GetNextPOId,
} from "../../redux/actions/proformaAction";
import { BuildPOData, DeletePoResource } from "../../redux/actions/action";
import { useDispatch, useSelector } from "react-redux";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Xicon from "../../assets/icons/Xicon.svg";
import searchicon from "../../assets/icons/search.svg";
import DownArrowOption from "../../assets/icons/DownArrowOption.svg";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import { europeanFormatWithSymbol } from "../../utils/European-Format/NumberFormatter";

const POPage = (props) => {
  const dispatch = useDispatch();

  const receivedProps = props?.location.state;
  console.log("asc443", receivedProps);
  const [addWorkPopup, setAddWorkPopup] = useState(false);
  const [itemPopup, setItemPopup] = useState(false);
  const [emailPopup, setEmailPopup] = useState(false);
  const [poResult, setPOResult] = useState([]);
  const isProjectAvailable = receivedProps !== undefined;
  const isClientAvailable = receivedProps !== undefined;
  const [totalPOAmount, setTotalPOAmount] = useState(null);
  const history = useHistory();
  const [selectedTask, setSelectedTask] = useState([]);
  const [poid, setPoid] = useState("");
  const [createdOn, setCreatedOn] = useState("");
  const [disableSelect, setDisableSelect] = useState(false);
  const [buttonLabel, setButtonLabel] = useState("Send PO");
  const [taskId, setTaskId] = useState("");

  useEffect(() => {
    GetProjectAndClient();
    if (receivedProps != undefined && receivedProps?.action == "task") {
      buildPurchaseOrder();
      setClientEmail(receivedProps.client?.contactEmil?.email);
      setSelectedClient(receivedProps.client.contactid);
      setSelectedProject(receivedProps.project.projectid);
      setDisableSelect(true);
      setNextPo();

      // new code
      setProjectid(receivedProps.project.projectid);
      setProjectName(receivedProps.project.projectname);
      setClientid(receivedProps.client.contactid);
      setClientName(receivedProps.client.contactname);
      // new code

      if (receivedProps?.associatedTasks && receivedProps?.associatedTasks[0])
        setTaskId(receivedProps?.associatedTasks[0]);
    } else if (
      receivedProps != undefined &&
      receivedProps?.action == "project"
    ) {
      setSelectedClient(receivedProps.client.clientId);
      setSelectedProject(receivedProps.project.projectId);
      setClientEmail(receivedProps.client?.clientEmail);

      // new code
      setProjectid(receivedProps.project.projectId);
      setProjectName(receivedProps.project.projectname);
      setClientid(receivedProps.client.clientId);
      setClientName(receivedProps.client.contactname);
      setClientEmail(receivedProps.client?.clientEmail);
      // new code

      setButtonLabel("Send PO");
      setNextPo();
    } else if (receivedProps != undefined && receivedProps?.action == "add") {
      setButtonLabel("Send PO");
      setNextPo();
    } else if (receivedProps != undefined && receivedProps?.action == "edit") {
      setSelectedClient(receivedProps.client.clientId);
      setSelectedProject(receivedProps.project.projectId);

      // new code
      setProjectid(receivedProps.project.projectId);
      setProjectName(receivedProps.project.projectName);
      setClientid(receivedProps.client.clientId);
      setClientName(receivedProps.client.clientName);
      // new code

      setPOResult(receivedProps.poResult);

      let total = 0;
      receivedProps.poResult.forEach((o) => {
        total += o.quantity * o.wageRate;
      });

      setTotalPOAmount(total);

      if (
        receivedProps &&
        receivedProps?.poResult &&
        receivedProps?.poResult[0]?.poid
      )
        setPoid(receivedProps.poResult[0].poid);

      let createdDate = new Date(receivedProps.poResult[0]?.createdOn);
      let dateLabel = `${("0" + createdDate.getDate().toString()).slice(-2)}.${(
        "0" + (createdDate.getMonth() + 1).toString()
      ).slice(-2)}.${createdDate.getFullYear()}`;
      setCreatedOn(dateLabel);

      setDisableSelect(true);
    } else if (
      localStorage.getItem("clientCOName") &&
      localStorage.getItem("clientCONameID")
    ) {
      setSelectedClient(localStorage.getItem("clientCONameID"));
    } else {
      setNextPo();
    }
  }, [props]);

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Proforma-List-Add-Update").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  const setNextPo = async () => {
    var nextPoid = await GetNextPOId();
    setPoid(nextPoid);

    let createdDate = new Date();
    let dateLabel = `${("0" + createdDate.getDate().toString()).slice(-2)}.${(
      "0" + (createdDate.getMonth() + 1).toString()
    ).slice(-2)}.${createdDate.getFullYear()}`;
    setCreatedOn(dateLabel);
  };

  const buildPurchaseOrder = async () => {
    var data = {
      associatedTasks: receivedProps.associatedTasks,
      addHourTrackedByEmployee: receivedProps.addHourTrackedByEmployee,
      addEquipmentUsed: receivedProps.addEquipmentUsed,
    };
    // var result = await BuildPO(receivedProps);
    var result = await dispatch(
      BuildPOData({
        associatedTasks: receivedProps.associatedTasks,
        addHourTrackedByEmployee: receivedProps.addHourTrackedByEmployee,
        addEquipmentUsed: receivedProps.addEquipmentUsed,
      }),
    );
    // setPOResult(result);
    setPOResult(Array.isArray(result) ? result : result?.data || []);
    const totalAmount = result?.data?.reduce(
      (total, po) => total + po.quantity * po?.wageRate,
      0,
    );
    setTotalPOAmount(totalAmount);
  };

  const [projectList, setProjectList] = useState([]);
  const [clientList, setClientLIst] = useState([]);
  const [selectedProject, setSelectedProject] = useState("");
  const [selectedClient, setSelectedClient] = useState("");
  const [completedTaskList, setCompletedTaskList] = useState([]);
  const [clientEmail, setClientEmail] = useState("");

  const [workPlaceHolder, setWorkPlaceholder] = useState("Choose a work");
  const [resourcePlaceholder, setResourcePlaceholder] =
    useState("Type an Item");

  const GetProjectAndClient = async () => {
    var projectResult = await GetProject();
    setProjectList(projectResult);
    setProjectsData(projectResult);
    var clientResult = await GetClient();
    setClientLIst(clientResult);
  };

  const handleProjectChange = (event) => {
    setSelectedProject(event.target.value);

    var selectedProj = projectList.filter(
      (o) => o.projectid == event.target.value,
    )[0];
    if (
      selectedProj &&
      selectedProj.clientid != "00000000-0000-0000-0000-000000000000" &&
      selectedProj.clientname &&
      selectedProj.clientname != null
    ) {
      setSelectedClient(selectedProj.clientid);
    } else {
      setSelectedClient("");
    }
  };

  const handleClientChange = (event) => {
    setSelectedClient(event.target.value);
  };

  const openAddWorkPopup = async () => {
    let porjectId = "";
    // old code
    if (selectedProject != "") {
      porjectId = selectedProject;
    } else {
      porjectId = receivedProps?.project?.projectid;
    }

    // new code
    if (projectid != "") {
      porjectId = projectid;
    } else {
      porjectId = receivedProps?.project?.projectid;
    }
    // new code

    var result = await GetWorkList(porjectId);
    setCompletedTaskList(result);
  };

  const [task, setTask] = useState("");
  const [resourceList, setResourceList] = useState([]);

  const openResourcePopup = async () => {
    var result = await GetResources(task);
    setResourceList(result);
  };

  const handleMakePO = async () => {
    const projectId =
      receivedProps != undefined
        ? receivedProps?.project?.projectid
        : selectedProject;
    const updatePOResult = poResult.map((a) => ({
      ...a,
      wageRate: a.wageRate || 0,
      resourceId: a.resourceId ? a.resourceId : a.userId,
    }));

    var data = {
      projectId: projectid ? projectid : selectedProject,
      clientId: clientid,
      requestedDate: new Date(),
      requestId: "",
      workOrder: "",
      totalAmount: totalPOAmount,
      clientPONumber: "",
      status: "Not Sent",
      isDeleted: false,
      resources: updatePOResult,
      clientEmail: typeEmail,
    };

    var apiResponse = await MakePO(data);
    history.goBack();
  };

  const handleSendPO = () => {
    const projectId =
      receivedProps != undefined
        ? receivedProps?.project?.projectid
        : selectedProject;
    const updatePOResult = poResult.map((a) => ({
      ...a,
      wageRate: a.wageRate || 0,
      resourceId: a.resourceId ? a.resourceId : a.userId,
    }));
    var data = {
      projectId: projectid ? projectid : selectedProject,
      clientId: clientid,
      requestedDate: new Date(),
      requestId: "",
      workOrder: "",
      totalAmount: totalPOAmount ? totalPOAmount : 0,
      clientPONumber: "",
      status: "Sent",
      isDeleted: false,
      resources: updatePOResult,
      email: typeEmail,
      clientEmail: typeEmail,
    };

    MakePO(data).then((res) => {
      if (taskId) {
        history.push(`/planboard/${taskId}`);
      } else {
        history.goBack();
      }
    });
  };

  const handleResources = (data) => {
    setPOResult((prevState) => [...prevState, data]);
    setTotalPOAmount(totalPOAmount + data.quantity * data?.wageRate);
    setWorkPlaceholder("Choose a work");
  };

  const deleteResource = (index) => {
    setPOResult((prevPoResult) => {
      const updatedPoResult = [...prevPoResult];
      updatedPoResult.splice(index, 1);
      return updatedPoResult;
    });
  };

  const calculateTotal = (quantity, wageRate) => {
    if (quantity == null || wageRate == null) {
      return " ";
    }

    const total = quantity * wageRate;
    return total.toFixed(2);
  };

  const [typeEmail, setTypeEmail] = useState(clientEmail);

  const handleEmailChange = (event) => {
    checkEmailValidation(event);
    setTypeEmail(event.target.value);
  };

  const isDisabled = !!clientEmail;

  /// ASC CLOSE DROP DOWN CLICK OUT SIDE START ///
  const Client_Popup_Ref = useRef(null);
  const hidden_Input_File = useRef(null);
  const Project_Popup_Ref = useRef(null);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (
      Client_Popup_Ref.current &&
      !Client_Popup_Ref.current.contains(event.target)
    ) {
      setClientShowOptions(false);
      setArrowOptionsRotate(false);
    }

    if (
      Project_Popup_Ref.current &&
      !Project_Popup_Ref.current.contains(event.target)
    ) {
      setProjectShowOptions(false);
      setArrowOptionsRotate2(false);
    }
  };
  /// ASC CLOSE DROP DOWN CLICK OUT SIDE END ///

  const [clientFlag, setclientFlag] = useState(false); // state for client error warning
  const [projectFlag, setProjectFlag] = useState(false); // state for project error warning
  const [quoteFlag, setQuoteFlag] = useState(false); // state for quote error warning

  const [searchProjectName, setSearchProjectName] = useState("");
  const [searchWork, setSearchWork] = useState("");
  const [searchSelf, setSearchSelf] = useState("");

  const [projectsData, setProjectsData] = useState([]);
  const [projectShowOptions, setProjectShowOptions] = useState(false);
  const [arrowOptionsRotate, setArrowOptionsRotate] = useState(false);
  const [arrowOptionsRotate2, setArrowOptionsRotate2] = useState(false);
  const [arrowOptionsRotate3, setArrowOptionsRotate3] = useState(false);
  const [arrowOptionsRotate4, setArrowOptionsRotate4] = useState(false);
  const [arrowOptionsRotate5, setArrowOptionsRotate5] = useState(false);
  const [projectName, setProjectName] = useState("");
  const [projectid, setProjectid] = useState("");
  const [typeInScreen, setTypeInScreen] = useState("");

  const [searchClientName, setSearchClientName] = useState("");
  const [clientName, setClientName] = useState("");
  const [clientAddress, setClientAddress] = useState("");
  const [clientCountry, setClientCountry] = useState("");
  const [clientData, setClientData] = useState([]);
  const [clientid, setClientid] = useState("");
  const [contactEmail, setContactEmail] = useState("");
  const [clientShowOptions, setClientShowOptions] = useState(false);

  const [validemail, setValidemail] = useState(false);

  const checkEmailValidation = (e) => {
    const emailPattern = /^[\w.-]+@[\w.-]+\.[A-Za-z]{2,}$/;
    const emails = e.target.value;
    if (!emailPattern.test(emails) && emails.trim() !== "") {
      setValidemail(true);
    } else {
      setValidemail(false);
      // setErrorfull(false);
    }
  };

  useEffect(() => {
    // console.log("asc44 clientList", clientList);
    // console.log("asc44 projectsData", projectsData);
    const filterData = clientList?.filter((x) => x?.clientId === clientid);
    // console.log("asc44 filterdata", filterData);

    setClientAddress(filterData[0]?.address);
  }, [clientList, projectsData, projectid]);

  const convertDecimalToHours = (time) => {
    const hours = Math.floor(Number(time));
    const minutes = Math.round((Number(time) - hours) * 60);

    return `${hours} Hr : ${minutes} min`;
  };

  const convertMinutesSecondsToHoursRoundoff = (time) => {
    const minutes = Math.floor(Number(time));
    const seconds = Math.round((Number(time) - minutes) * 100);

    const totalMinutes = minutes + seconds / 60;

    const hours = Math.floor(totalMinutes / 60);
    const remainingMinutes = Math.round(totalMinutes % 60);

    return `${hours} Hr : ${remainingMinutes} min`;
  };

  const convertMinutesSecondsToHours = (time) => {
    const minutes = Math.floor(Number(time));
    const seconds = Math.floor((Number(time) - minutes) * 100);

    const totalMinutes = minutes + seconds / 60;

    const hours = Math.floor(totalMinutes / 60);
    const remainingMinutes = Math.floor(totalMinutes % 60);

    return `${hours} Hr : ${remainingMinutes} min`;
  };

  return (
    <>
      <div className="header-content">
        <div className="request-po-title">
          {/* Request PO ID */}
          {t("Request PO ID")}
          &nbsp;&nbsp;{" "}
          <strong>
            {poid}
            <label className="color-gray">&nbsp;-&nbsp;{createdOn}</label>
          </strong>
        </div>
        <div
          className="mobile-all-button-size"
          style={{ display: "flex", gap: "20px" }}
        >
          <Button
            onClick={() => {
              history.goBack();
            }}
            variant="outlined"
            className="mobile-cancel-size"
            style={{
              color: "white",
              borderColor: "#5B5B5B",
              borderRadius: "8px",
              fontWeight: "bold",
              width: "132px",
              height: "42px",
              fontSize: "14px",
            }}
          >
            {/* Cancel */}
            {t("Cancel")}
          </Button>
          <Button
            variant="outlined"
            className="mobile-save-po-size"
            disabled={poResult.length === 0 || !projectid || !clientid}
            style={{
              color: "#00246A",
              borderColor: "#5B5B5B",
              borderRadius: "8px",
              background: "#D2DCE9",
              fontWeight: "bold",
              width: "132px",
              height: "42px",
              fontSize: "14px",
            }}
            onClick={() => {
              handleMakePO();
            }}
          >
            {/* Save PO */}
            {t("Save PO")}
          </Button>
          <p
            className="m-0 new-class-name d-flex justify-content-center align-items-center me-3 mobile-make-po-size pointer"
            style={{
              width: "132px",
              height: "42px",
              borderColor: "#5B5B5B",
              borderRadius: "8px",
              background: "#00246a",
              fontWeight: "bold",
              color: "white",
              fontSize: "14px",
            }}
            onClick={() => {
              setEmailPopup(!emailPopup);
            }}
          >
            {/* {buttonLabel} */}
            {t("Make PO") || buttonLabel}
          </p>
          {emailPopup && (
            <div className="email-popup" style={{ right: "55px" }}>
              <TextField
                id="outlined-basic"
                label="Client Email"
                variant="outlined"
                style={{
                  color: "#5B5B5B",
                  borderColor: "#5B5B5B",
                  borderRadius: "8px",
                  width: "100%",
                }}
                defaultValue={clientEmail}
                onChange={handleEmailChange}
              />
              <div className={validemail ? "errmsg" : "errmsghide"}>
                Enter a valid email
                {/* {t("Enter a valid email")} */}
              </div>
              <p
                className="m-0 task-modal-cancel-btn1-pop me-3"
                style={{
                  background: "#D2DCE9",
                  color: "#00246A",
                  pointerEvents:
                    typeEmail === "" || validemail ? "none" : "auto",
                }}
                onClick={() => {
                  handleSendPO();
                  setEmailPopup(false);
                }}
              >
                {/* Send */}
                {t("Send")}
              </p>
            </div>
          )}
        </div>
      </div>

      <div
        className="project-client-container mt-3 gap-2 d-none"
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: "40px",
        }}
      >
        <div>
          <p>
            {/* PROJECT */}
            {t("PROJECT")}
          </p>
          <Select
            className="project-id mobile-width-project"
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={selectedProject ? selectedProject : null}
            disabled={disableSelect}
            onChange={handleProjectChange}
          >
            {
              // isProjectAvailable ? (
              //     <MenuItem value={`${receivedProps?.project?.projectname}`}>
              //         {`${receivedProps?.project.projectname}`}
              //     </MenuItem>
              // ) :
              projectList?.map((proj) => (
                <MenuItem value={proj.projectid}>
                  {proj.projectname ? proj.projectname : " "}
                </MenuItem>
              ))
            }
          </Select>
        </div>
        <div>
          <p className="mobile-psotion-client">
            {/* CLIENT */}
            {t("CLINENT")}
          </p>
          <Select
            className="client-id mobile-width-client"
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={selectedClient ? selectedClient : null}
            disabled={disableSelect}
            onChange={handleClientChange}
          >
            {
              // isClientAvailable ? (
              //     <MenuItem value={`${receivedProps?.client?.contactname}`}>
              //         {`${receivedProps?.client?.contactname}`}
              //     </MenuItem>
              // ) :
              clientList?.map((client) => (
                <MenuItem
                  onClick={() => {
                    setClientEmail(client?.email?.email);
                  }}
                  value={client?.clientId}
                >
                  {client?.clientName}
                </MenuItem>
              ))
            }
          </Select>
        </div>
      </div>

      {/* New Proforma Ui start */}
      <div
        className="project-client-container pt-0 gap-2"
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          padding: "40px",
        }}
      >
        <div className="asc-input-container col-12 col-md-5" id="ascInput">
          <label className="asc-label-top ClientNameText">
            Project
            {/* {t("PROJECT")} */}
            <span style={{ color: "red" }}>*</span>
          </label>
          <div
            className="asc_Client_Input_Div_For_LongDiv22"
            style={{ width: "auto" }}
            ref={Project_Popup_Ref}
          >
            <input
              type="text"
              id="asc_po_placeHolder"
              className="asc_Client_Input_For_Long ps-4"
              placeholder="Select Project"
              // placeholder={t("Select Project")}
              value={projectName}
              onChange={(e) => {
                setProjectName(e.target.value);
                setProjectShowOptions(true);
              }}
              onFocus={() => {
                setProjectShowOptions(true);
                setArrowOptionsRotate2(true);
              }}
            />

            {projectName ? (
              <img
                src={Xicon}
                className="xicon pointer"
                alt=""
                onClick={() => {
                  setSearchProjectName("");
                  setProjectName("");
                  setProjectid("");
                  setTypeInScreen("asc");
                }}
              />
            ) : (
              <img
                src={DownArrowOption}
                className={arrowOptionsRotate2 ? "upArrow" : "downArrow"}
                alt=""
                onClick={() => {
                  setProjectShowOptions(true);
                  setArrowOptionsRotate2(true);
                }}
              />
            )}

            {projectShowOptions && (
              <div
                className="asc_Custom_Select_Outer_Project"
                style={{
                  transform: projectShowOptions ? "scale(1)" : "scale(0)",
                  transitionDuration: "300ms",
                }}
              >
                <p className="asc_Search_Client_Text pt-2 ps-3 pb0">
                  Select Project
                  {/* {t("Select Project")} */}
                </p>
                <section className="asc_Search_Icon_Search mx-2">
                  <img
                    src={searchicon}
                    className="asc_searchicon"
                    alt="Search Icon"
                  />
                  <input
                    className="asc_Search_Input"
                    placeholder="Search..."
                    value={searchProjectName}
                    onChange={(e) => setSearchProjectName(e.target.value)}
                  />
                </section>

                <section
                  className="asc_Search_List_Project pt-0"
                  id="ascSelectBox"
                >
                  {projectsData
                    .filter((item) =>
                      item.projectname
                        ?.toLowerCase()
                        .includes(searchProjectName.toLowerCase()),
                    )
                    .map((item, index) => {
                      return (
                        <div
                          key={index}
                          className="ulterDrop"
                          onClick={() => {
                            setSearchProjectName("");
                            setProjectName(item.projectname);
                            setProjectid(item.projectid);
                            setContactEmail(item.contactemail);
                            setClientName(item.clientname);
                            setClientid(item.clientid);
                            // dispatch(
                            //   FetchQuotes(
                            //     // projectid,
                            //     item.projectid,
                            //     pageNumber,
                            //     itemsPerPage,
                            //   ),
                            // );
                            // setPaymentDeadline(item.paymentdeadline ?? "");
                            // setPaymentDeadlineid(item.paymentTerms ?? "");
                            setProjectShowOptions(false);
                            setTypeInScreen("asc");
                            setProjectFlag(false); // project error warning
                          }}
                          onChange={handleProjectChange}
                        >
                          <p className="ps- mb-0">{item.projectname}</p>
                        </div>
                      );
                    })}
                  {projectsData.length === 0 && (
                    <span className="noDataDisplay">
                      No data to display!
                      {/* {t("No data to display!")} */}
                      {/* {FetchTranslationList?.data?.data[94]?.translation} */}
                    </span>
                  )}
                </section>
              </div>
            )}
          </div>
          {/* show warning for project  gaurav start*/}
          {projectFlag && (
            <p style={{ color: "red", fontSize: "10px" }}>
              Please select project first!
              {/* {t("Please select project first!")} */}
            </p>
          )}
          {/* show warning for project  gaurav end*/}
        </div>

        <div className="asc-input-container col-12 col-md-5" id="ascInput">
          <label className="asc-label-top ClientNameText">
            Client
            {/* {t("CLIENT")} */}
            <span style={{ color: "red" }}>*</span>
          </label>
          <div
            className="asc_Client_Input_Div_For_LongDiv d-flex"
            style={{ width: "auto", pointerEvents: "none" }}
            ref={Client_Popup_Ref}
          >
            <p
              className="asc_Client_Input_For_Long ps-3"
              onClick={() => {
                setClientShowOptions(true);
                setArrowOptionsRotate(true);
              }}
            >
              {clientName ? clientName : "Select Client"}
              {/* {selectedClient ? selectedClient : null} */}

              <br />
              <p className="clintAddress pt-2">{clientAddress}</p>
              <p className="clintAddress">{clientCountry}</p>
            </p>

            {clientName ? (
              <img
                src={Xicon}
                className="xicon pointer"
                alt=""
                onClick={() => {
                  setSearchClientName("");
                  setClientName("");
                  setClientid("");
                  setClientAddress("");
                  setClientCountry("");
                  setTypeInScreen("asc");
                  // setClientShowOptions(false);
                  // setShowOptions(!showOptions);
                  setSearchProjectName("");
                  setProjectName("");
                  setProjectid("");
                  // setQuotecode("");
                  // setQuoteid("");
                }}
              />
            ) : (
              <img
                src={DownArrowOption}
                className={arrowOptionsRotate ? "upArrow" : "downArrow"}
                alt=""
                onClick={() => {
                  setClientShowOptions(true);
                  setArrowOptionsRotate(true);
                }}
              />
            )}

            {clientShowOptions && (
              <div
                className="asc_Custom_Select_Outer22"
                style={{
                  transform: clientShowOptions ? "scale(1)" : "scale(0)",
                  transitionDuration: "300ms",
                }}
              >
                <p className="asc_Search_Client_Text pt-2 ps-2">
                  Search Client
                  {/* {t("Search Client")} */}
                </p>
                <section className="asc_Search_Icon_Search mx-2">
                  <img
                    src={searchicon}
                    className="asc_searchicon"
                    alt="Search Icon"
                  />
                  <input
                    id="asc_input"
                    className="asc_Search_Input"
                    placeholder="Search..."
                    value={searchClientName}
                    onChange={(e) => setSearchClientName(e.target.value)}
                  />
                </section>

                <section className="asc_Search_List pt-0 p-3" id="ascSelectBox">
                  {clientData
                    .filter((item) =>
                      item.name
                        ?.toLowerCase()
                        .includes(searchClientName.toLowerCase()),
                    )
                    .map((item, index) => {
                      return (
                        <div
                          key={index}
                          className=""
                          onClick={() => {
                            setSearchClientName("");
                            setClientName(item.name);
                            setClientid(item.id);
                            // dispatch(FetchProjectByClient(item.id));
                            setClientAddress(item.address);
                            setContactEmail(item.email);
                            // setProfessionalAddress(item.professionalAddress);
                            // setPersonalAddress(item.personalAddress);
                            // setZipCode(item.zipCode);
                            // setCity(item.city);
                            setClientCountry(item.country);
                            setClientShowOptions(false);
                            setTypeInScreen("asc");
                            setclientFlag(false); // client error warning
                          }}
                          onChange={handleClientChange}
                        >
                          <p
                            className={
                              clientid === item.id
                                ? "asc_Selected_Item ps-3"
                                : "ps-3"
                            }
                          >
                            {item.name}
                          </p>
                        </div>
                      );
                    })}
                  {clientData.length === 0 && (
                    <span className="noDataDisplay">
                      No data to display!
                      {/* {t("No data to display!")} */}
                      {/* {FetchTranslationList?.data?.data[94]?.translation} */}
                    </span>
                  )}
                </section>
              </div>
            )}
          </div>
          {/* show warning for client  gaurav start*/}
          {clientFlag && (
            <p style={{ color: "red", fontSize: "10px" }}>
              Please select client first!
              {/* {t("Please select client first!")} */}
            </p>
          )}
          {/* show warning for client  gaurav end*/}
        </div>
      </div>
      {/* New Proforma Ui end */}

      <div style={{ overflow: "auto" }}>
        <div
          className="mobile-fixed-width"
          style={{
            margin: "0 40px",
            padding: "5px",
            background: "white",
            maxHeight: "433px",
          }}
        >
          <table>
            <thead>
              <tr
                className="accordian-summary-heading-div"
                style={{ borderBottom: "1px solid #000" }}
              >
                <th>
                  {/* WORK */}
                  {t("WORK")}
                </th>
                <th>
                  {/* RESOURCE */}
                  {t("RESOURCE")}
                </th>
                <th>
                  {/* TYPE */}
                  {t("TYPE")}
                </th>
                <th>
                  {/* QTY */}
                  {t("QTY")}
                </th>
                <th>
                  {/* U.Price */}
                  {t("U.Price")}
                </th>
                <th>
                  {/* TOTAL AMOUNT */}
                  {t("TOTAL AMOUNT")}
                </th>
              </tr>
            </thead>
            <tbody>
              <React.Fragment>
                {poResult?.map((po, index) => (
                  <tr
                    className="accordian-summary-heading-div"
                    style={{ borderBottom: "1px solid #000", color: "#323232" }}
                  >
                    <td>{po.taskName}</td>
                    <td>{po.name}</td>
                    {/* <td>{po.type}</td> */}
                    <td>{po.type === "Daily" ? "Daily" : "-"}</td>
                    {/* <td>{convertDecimalToHours(po.quantity)}</td> */}
                    <td>
                      {po.type === "DailyNOneed"
                        ? convertDecimalToHours(po.quantity)
                        : convertMinutesSecondsToHours(po.quantity)}
                    </td>
                    <td>{europeanFormatWithSymbol(po.wageRate)}</td>
                    <td style={{ fontWeight: "bold" }}>
                      &euro; {calculateTotal(po.quantity, po.wageRate)}
                    </td>
                    <Tooltip title="Delete" color={"red"}>
                      <td
                        style={{
                          display: "flex",
                          gap: "10px",
                          height: "45px",
                          alignItems: "center",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          deleteResource(index);
                          if (po?.voucherResourceId) {
                            dispatch(DeletePoResource(po?.voucherResourceId));
                          }
                        }}
                      >
                        <img src={trash} alt="" />
                      </td>
                    </Tooltip>
                  </tr>
                ))}
                <tr className="accordian-summary-heading-div">
                  <td
                    style={{
                      color: "#9A9999",
                      fontSize: "14px",
                      position: "relative",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      openAddWorkPopup();
                      setAddWorkPopup(true);
                    }}
                  >
                    {workPlaceHolder}
                  </td>
                  <td
                    style={{
                      color: "#9A9999",
                      cursor: "pointer",
                      fontSize: "14px",
                    }}
                    onClick={() => {
                      openResourcePopup();
                      setItemPopup(true);
                    }}
                  >
                    {resourcePlaceholder}
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                {addWorkPopup && (
                  <div className="project-popup-request-po">
                    <div
                      className="py- px-4"
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        background: "#f1f1f1",
                        alignItems: "center",
                        borderRadius: "8px",
                      }}
                    >
                      <p
                        style={{
                          fontWeight: "bolder",
                          margin: "0",
                          color: "#333",
                          fontSize: "16px",
                        }}
                      >
                        {/* Work Completed */}
                        {t("Work Completed")}
                      </p>

                      <section className="asc_Search_Icon_Search_Invoice mx-2">
                        <input
                          className="asc_Search_Input_Invoice"
                          placeholder="Search..."
                          value={searchWork}
                          onChange={(e) => setSearchWork(e.target.value)}
                        />
                        <img
                          src={searchicon}
                          className="asc_searchicon_Invoice me-2"
                          alt="Search Icon"
                        />
                      </section>

                      <img
                        alt=""
                        src={x}
                        style={{
                          width: "clamp(22px, 1.146vw, 1.146vw)",
                          height: "clamp(22px, 1.146vw, 1.146vw)",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setAddWorkPopup(false);
                        }}
                      />
                    </div>
                    <div
                      className="px-4 py-2"
                      style={{
                        overflowY: "auto",
                        height: "auto",
                        maxHeight: "550px",
                      }}
                    >
                      {completedTaskList
                        ?.filter((x) =>
                          x.taskname
                            .toLowerCase()
                            .includes(searchWork.toLowerCase()),
                        )
                        .map((task) => (
                          <p
                            className="accordian-summary-heading-di-v mb-0"
                            style={{
                              cursor: "pointer",
                              borderTop: "2px dashed #70707080",
                              padding: "10px 0px",
                              fontSize: "16px",
                            }}
                            onClick={() => {
                              const isAlreadySelected = selectedTask.some(
                                (x) => x.taskid === task.taskid,
                              );
                              // if (isAlreadySelected) return false;

                              setTask(task.taskid);
                              setWorkPlaceholder(task.taskname);
                              setAddWorkPopup(false);

                              if (!isAlreadySelected) {
                                setSelectedTask((prevSelectedTask) => [
                                  ...prevSelectedTask,
                                  task,
                                ]);
                              }
                            }}
                          >
                            {task.taskname}
                          </p>
                        ))}
                    </div>
                  </div>
                )}
                {itemPopup && (
                  <div className="project-popup-request-po">
                    <div
                      className="py- px-4"
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        background: "#f1f1f1",
                        alignItems: "center",
                        borderRadius: "8px",
                      }}
                    >
                      <p
                        style={{
                          fontWeight: "bolder",
                          margin: "0",
                          color: "#333",
                          fontSize: "16px",
                        }}
                      >
                        {/* Self 1 */}
                        {t("Self 1")}
                      </p>

                      <section className="asc_Search_Icon_Search_Invoice mx-2">
                        <input
                          className="asc_Search_Input_Invoice"
                          placeholder="Search..."
                          value={searchSelf}
                          onChange={(e) => setSearchSelf(e.target.value)}
                        />
                        <img
                          src={searchicon}
                          className="asc_searchicon_Invoice me-2"
                          alt="Search Icon"
                        />
                      </section>

                      <img
                        alt=""
                        src={x}
                        style={{
                          width: "clamp(22px, 1.146vw, 1.146vw)",
                          height: "clamp(22px, 1.146vw, 1.146vw)",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setItemPopup(false);
                        }}
                      />
                    </div>
                    <div
                      className="px-4 py-2"
                      style={{
                        overflowY: "auto",
                        height: "auto",
                        maxHeight: "550px",
                      }}
                    >
                      {resourceList
                        ?.filter((x) =>
                          x.name
                            .toLowerCase()
                            .includes(searchSelf.toLowerCase()),
                        )
                        .map((res) => (
                          <p
                            className="accordian-summary-heading-di-v mb-0"
                            style={{
                              cursor: "pointer",
                              borderTop: "2px dashed #70707080",
                              padding: "10px 0px",
                              fontSize: "16px",
                            }}
                            onClick={() => {
                              const isAlreadySelected = poResult?.some(
                                (x) =>
                                  x.resourceId === res.resourceId &&
                                  (x.taskId || x.taskid) === task,
                              );
                              if (isAlreadySelected) return false;

                              handleResources(res);
                              setItemPopup(false);
                            }}
                          >
                            {res.name}
                          </p>
                        ))}
                    </div>
                  </div>
                )}
                <tr
                  style={{
                    borderTop: "1px solid grey",
                    textAlign: "-webkit-left",
                  }}
                >
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>
                    {/* TOTAL AMOUNT Exc. VAT */}
                    {t("TOTAL AMOUNT Exc. VAT")}
                  </td>
                  <td style={{ fontWeight: "bold" }}>
                    &euro;{" "}
                    {totalPOAmount != null ? totalPOAmount.toFixed(2) : ""}
                  </td>
                </tr>
              </React.Fragment>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default POPage;
